// app/packs/member/redux/modules/futureRemComparison.js

import api, { handleAPIErrors } from "shared/api";

const FETCH_REQUEST = "futureRemComparison/FETCH_REQUEST";
const FETCH_SUCCESS = "futureRemComparison/FETCH_SUCCESS";
const FETCH_FAILURE = "futureRemComparison/FETCH_FAILURE";
const SET_FUTURE_REM_COMPARISON =
  "futureRemComparison/SET_FUTURE_REM_COMPARISON";
const REMOVE_FUTURE_REM_COMPARISON =
  "futureRemComparison/REMOVE_FUTURE_REM_COMPARISON";

const initialState = {
  futureRemComparison: [],
  loaded: false,
  loading: false,
  errors: [],
};

export function fetchRequest() {
  return { type: FETCH_REQUEST };
}

export function fetchSuccess(payload) {
  return { type: FETCH_SUCCESS, payload };
}

export function fetchFailure(errors = []) {
  return { type: FETCH_FAILURE, errors };
}

export const setFutureRemComparison = (result) => ({
  type: SET_FUTURE_REM_COMPARISON,
  payload: result,
});

export const removeFutureRemComparison = (memberId, role) => ({
  type: REMOVE_FUTURE_REM_COMPARISON,
  payload: { memberId, role },
});

export function loadFutureRemComparison(options, cb = null) {
  return (dispatch) => {
    dispatch(fetchRequest());

    return api(`api/v1/remunerations/future_remunerations`, options)
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }
        console.log("API result", json);
        dispatch(setFutureRemComparison(json));
        if (cb) cb();
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors));
        });
        if (cb) cb();
      });
  };
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;
  switch (type) {
    case FETCH_REQUEST:
      return { ...state, loading: true };
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: [],
        futureRemComparison: Array.isArray(payload) ? payload : [payload],
      };
    case FETCH_FAILURE:
      return { ...state, loaded: false, loading: false, errors };
    case SET_FUTURE_REM_COMPARISON: {
      if (!payload) return state;
      const newResult = payload;
      const idx = state.futureRemComparison.findIndex(
        (item) => item.id === newResult.id
      );
      let newArray;
      if (idx > -1) {
        newArray = [...state.futureRemComparison];
        newArray[idx] = newResult;
      } else {
        newArray = [...state.futureRemComparison, newResult];
      }
      return {
        ...state,
        futureRemComparison: newArray,
      };
    }
    case REMOVE_FUTURE_REM_COMPARISON:
      return {
        ...state,
        futureRemComparison: state.futureRemComparison.filter(
          (item) =>
            String(item.company_csuite_member?.id) !==
              String(action.payload.memberId) ||
            item.role !== action.payload.role
        ),
      };
    default:
      return state;
  }
}
